<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_9" id="id_Hlk513668773">To my husband Craig. I better always be the one you’d go to jail for.</p>
<p class="block_" id="id_Hlk104914893"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?27a8c9cc